import professor from './assets/mock/professor.png';
import orientador from './assets/mock/orientador.png';
import pokedex from './assets/mock/pokedex.png';
import flix from './assets/mock/flix.png';
import sistema from './assets/mock/sistema.png';
import cardapio from './assets/mock/cardapio.png';
import energygym from './assets/mock/energygym.png';

const ProjectsData = [
    {
        "id": 5,
        "img": energygym,
        "title": "Academia EnergyGym",
        "description": "é uma plataforma interativa para academias, com uma interface responsiva e animações suaves. O site permite uma navegação fluida entre seções e possui uma aba para adicionar o e-mail, com envio via EmailJS. Desenvolvido com React, o projeto utiliza Framer Motion para animações e React Scroll para rolagem suave",
        "tool": "React · Framer Motion · React Scroll · EmailJS",
        "github": "https://github.com/EvertonSantana01/energygym-front",
        "link": "https://energygym.pages.dev"
    },
    {
        "id": 1,
        "img": cardapio,
        "title": "Cardápio Digital",
        "description": "Um sistema prático e intuitivo para gerenciamento de cardápios. Permite cadastrar pratos com nome, preço e imagem, exibindo-os automaticamente em uma interface responsiva e amigável. Desenvolvido com um back-end robusto em Java utilizando Spring Boot e um front-end moderno em React com TypeScript, o projeto une eficiência e simplicidade.",
        "tool": "Java · Spring Boot · PostgreSQL · JPA · React · TypeScript · Vite · Axios · React Query",
        "github": "https://github.com/EvertonSantana01/cardapio-digital",
        "link": "https://www.youtube.com/watch?v=hb1WxHGRG14"
    },
    {
        "id": 3,
        "img": sistema,
        "title": "Gerenciamento De Cadastros",
        "description": "Um sistema eficiente para gerenciar cadastros, vendas e estoque. Permite cadastro, edição e exclusão de estados, cidades, funcionários, clientes, fornecedores e produtos, além de registro e histórico de vendas e entradas de produtos. Conta com interface responsiva e segue boas práticas de desenvolvimento.",
        "tool": "Java · Spring Boot · PostgreSQL · JPA · Thymeleaf · Bootstrap · Maven · JUnit · Mockito",
        "github": "https://github.com/EvertonSantana01/GerenciamentoDeCadastros-java",
        "link": "https://youtu.be/eN6YZk3tL_s?si=Y1AysczARgo-LCR3"
    },
    {
        "id": 2,
        "img": orientador,
        "title": "Customer Registration",
        "description": "Um sistema prático para cadastro de clientes. Basta inserir nome e e-mail, e o sistema cuida do resto: salva no banco de dados e exibe as informações na tela, com a opção de deletar se necessário.",
        "tool": "React · Vite · Node.js · Fastify · MongoDB · Prisma · ESLint · TypeScript.",
        "github": "https://github.com/EvertonSantana01/registration-customer",
        "link": "https://github.com/EvertonSantana01/registration-customer"
    },


]

export default ProjectsData;